/*
*###############################################################################
*Module Name                   : ReasonTypesMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Tuesday, September 7th 2021, 10:01:02 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/


import React, { useState } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPDropDown from 'framework/components/DPDropDown'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/ReasonTypes.xlsx";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPDropDownMultiSelect from 'framework/components/DPDropDownMultiSelect'

const ReasonTypesMasterContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    TransTypeValue,
    TransTypeOnChanage,
    DiscountPerceValue,
    DiscountPerceOnChange,
    DisAmountValue,
    DisAmountOnChange,
    DisPerStartValue,
    DisPerStartOnChange,
    DisPerEndValue,
    DisPerEndOnChange,
    PermisValue,
    PermisOnChange,
    ReturnValue,
    ReturnOnChange,
    CancelValue,
    CancelOnChange,
    InstruValue,
    InstruOnChange,
    ManuDisValue,
    ManuDisOnChange,
    NetDisValue,
    NetDisOnChange,
    PosoperationOnChange,
    PosoperationValue,
    CodeOnBlur,
    ErrorMsg,
    percentOnBlur,
    amountOnBlur,
    startonBlur,
    endOnBlur,
    transaction,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    showFileUpload,
    valueUpload,
    menuCode,
    autoCode,
    bitDetailLvlOnChange,
    bitSummaryLvlOnChange,
    bitDetailLvl,
    bitSummaryLvl,
    reqTxnRef1,
    reqTxnRef1OnChange
}) => {

    const [groupFilter, SetGroupFilter] = useState("a")
    const ApiURL = window.Links.ApiURL

    async function tog_backdrop() {
        modelTrigger();
    }

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];


    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <Row>
                                    <Col sm={12} md={11} className="mb-4-sm">
                                        <DPTextBoxButton
                                            rowClass="mb-4-sm"
                                            labelText="Code *"
                                            textType="text"
                                            maxLength="5"
                                            value={CodeValue}
                                            onChange={CodeonChange}
                                            onBlur={CodeOnBlur}
                                            disabled={disabled == true ? disabled : disabledCode}
                                            onButtonClick={onButtonClick}
                                            btnDisable={disabled == true ? disabled : btnDisable}
                                            placeholder={autoCode}
                                        />
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Description *"
                                            textType="text"
                                            maxLength="50"
                                            value={DescValue}
                                            onChange={DescOnChange}
                                            disabled={disabled}
                                        />
                  

                                        <DPDropDownMultiSelect
                                            selectedGroup={TransTypeValue}
                                            onChange={TransTypeOnChanage}
                                            optionGroup={transaction}
                                            labelText={'Transaction Type'}
                                            disabled={disabled}
                                        />

                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Discount % "
                                            textType="text"
                                            maxLength="50"
                                            textAlign="right"
                                            value={ManuDisValue == true ? "0.0" : DiscountPerceValue}
                                            onChange={DiscountPerceOnChange}
                                            disabled={ManuDisValue == true ? true : disabled}
                                            onBlur={percentOnBlur}
                                        />
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Discount Amount"
                                            textType="text"
                                            maxLength="50"
                                            textAlign="right"
                                            value={ManuDisValue == true ? "0.0" : DisAmountValue}
                                            onChange={DisAmountOnChange}
                                            disabled={ManuDisValue == true ? true : disabled}
                                            onBlur={amountOnBlur}
                                        />
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Discount Start %"
                                            textType="text"
                                            maxLength="50"
                                            textAlign="right"
                                            value={ManuDisValue == true ? "0.0" : DisPerStartValue}
                                            onChange={DisPerStartOnChange}
                                            disabled={ManuDisValue == true ? true : disabled}
                                            onBlur={startonBlur}
                                        />
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Discount End %"
                                            textType="text"
                                            maxLength="50"
                                            textAlign="right"
                                            value={ManuDisValue == true ? "0.0" : DisPerEndValue}
                                            onChange={DisPerEndOnChange}
                                            disabled={ManuDisValue == true ? true : disabled}
                                            onBlur={endOnBlur}
                                        />
                                    </Col>

                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Button
                                            onClick={() => {
                                                tog_backdrop()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={SearchDisable}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>

                                </Row>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">

                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}
                                        />
                                    </Col>

                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Permission
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={PermisOnChange}
                                            checked={PermisValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={8}><Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Reason For Return
                                    </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={ReturnOnChange}
                                            checked={ReturnValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Reason For Cancellation
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={CancelOnChange}
                                            checked={CancelValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}><Label
                                        htmlFor="example-text-input"
                                        className={`col-md-12 col-form-label-sm`}
                                    >
                                        Instruction
                                    </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={InstruOnChange}
                                            checked={InstruValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Reason For Manual Discount
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={ManuDisOnChange}
                                            checked={ManuDisValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Net Discount Percentage
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={NetDisOnChange}
                                            checked={NetDisValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            POS Operation
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={PosoperationOnChange}
                                            checked={PosoperationValue}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Summary Level
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={bitSummaryLvlOnChange}
                                            checked={bitSummaryLvl}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Detail Level
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={bitDetailLvlOnChange}
                                            checked={bitDetailLvl}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={8}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Req Txn Ref1
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={reqTxnRef1OnChange}
                                            checked={reqTxnRef1}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabledCode}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />

                                        <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                                            style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>
                            </Col>

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"REASONTYPE"}
                                MenuCode={menuCode}
                                KeyVal={"RES"}
                                searchBy={"RC_CODE"}
                                FilterStr={groupFilter}
                            />


                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default ReasonTypesMasterContent